import { globalTimeFormat } from "../../../../../components/Security";

export function SetInfoForUpload({ header, _cell }) {
	const data = _cell.render("Cell").props.row.original;
	const value = _cell.render("Cell").props.value;

	if (header === "Photo") {
		if (data.photo) {
			const imageSrc = "data:image/jpeg;base64," + data.photo;

			return (
				<td>
					<img className="avatarImg" src={imageSrc} alt="" />
				</td>
			);
		}
		return (
			<td>
				<img className="avatarImg" src="images/sample.jpg" alt="" />
			</td>
		);
	}

	if (header === "Date Created") {
		if (!value) {
			return <td></td>;
		}

		const date = new Date(_cell.render("Cell").props.value);
		if (!date) {
			return <td>-</td>;
		}

		const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
		const dd = date.getDate();
		const yyyy = date.getFullYear();

		const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

		return <td>{formattedDateFrom}</td>;
	}

	if (header === "Error") {
		return (
			<td>{value && <p style={{ color: "red", margin: 0 }}>{value}</p>}</td>
		);
	}

	if (
		header === "Vacation Leave" ||
		header === "Sick Leave" ||
		header === "Service Incentive Leave" ||
		header === "Solo Parent Leave" ||
		header === "Vacation Leave Remaining" ||
		header === "Sick Leave Remaining" ||
		header === "Service Incentive Leave Remaining" ||
		header === "Solo Parent Leave Remaining"
	) {
		const value = _cell.render("Cell").props.value;

		// Check if value is a number
		const isNumber = typeof value === "number";

		const numberWithCommasAndDecimal = (number) => {
			return number.toLocaleString("en-US", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		};

		if (!isNumber) {
			return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
		}

		const formattedNumber = numberWithCommasAndDecimal(value);

		return <td>{formattedNumber}</td>;
	}

	if (
		header === "Time From" ||
		header === "Time To" ||
		header === "Time In" ||
		header === "Time Out"
	) {
		let time = _cell.render("Cell").props.value;

		if (!time) {
			return <td></td>;
		}

		let timeParts;
		let formattedTime;

		if (globalTimeFormat === "Standard Time") {
			const timeSplit = time.split("T");
			if (timeSplit.length > 1) {
				timeParts = timeSplit[1].substr(0, 5).split(":");
			} else {
				timeParts = [];
			}
			let hours = parseInt(timeParts[0], 10);
			const minutes = timeParts[1];

			// Convert 24-hour format to 12-hour format and determine AM or PM
			const amPm = hours >= 12 ? "PM" : "AM";
			hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

			formattedTime = `${hours}:${minutes} ${amPm}`;
		} else if (globalTimeFormat === "Military Time") {
			const timeSplit = time.split("T");
			if (timeSplit.length > 1) {
				timeParts = timeSplit[1].substr(0, 5).split(":");
			} else {
				timeParts = [];
			}
			let hours = parseInt(timeParts[0], 10);
			const minutes = timeParts[1];

			formattedTime = `${hours}:${minutes}`;
		}

		return <td>{formattedTime}</td>;
	}

	return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}